"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPencil = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var React = __importStar(require("react"));

exports.IconPencil = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return (0, jsx_runtime_1.jsxs)("svg", _objectSpread(_objectSpread({
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef,
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M0.516092 39.4839C0.104394 39.0765 -0.0776115 38.4915 0.0307229 37.9238L2.21488 23.4842C2.26906 23.118 2.43807 22.7778 2.70025 22.5135L23.8135 1.52109C25.8439 -0.507031 29.1331 -0.507031 31.1634 1.52109L38.4789 8.83658C40.507 10.8669 40.507 14.1561 38.4789 16.1865L17.4172 37.2997C17.1529 37.5619 16.8127 37.7309 16.4465 37.7851L2.07621 39.9693C1.50852 40.0776 0.92347 39.8956 0.516092 39.4839ZM5.54313 24.6455L3.80967 36.19L15.3542 34.4566L36.1558 13.7593C36.8275 13.0833 36.8275 11.9912 36.1558 11.3152L28.7016 3.93091C28.0255 3.25921 26.9335 3.25921 26.2575 3.93091L5.54313 24.6455Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M33.9787 18.5136L21.5188 6.83249C20.8271 6.18399 20.8271 5.13488 21.5188 4.48638C22.2105 3.83787 23.3296 3.83787 24.0213 4.48638L36.4812 16.1675C37.1729 16.816 37.1729 17.8651 36.4812 18.5136C35.7895 19.1621 34.6704 19.1621 33.9787 18.5136Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M15.1802 37.4875L3.48025 25.0076C2.83992 24.3201 2.83992 23.2096 3.48025 22.5222C3.7901 22.1895 4.21355 22 4.65358 22C5.0936 22 5.51702 22.1895 5.8269 22.5222L17.5104 34.9846C17.8224 35.3151 18 35.7668 18 36.2362C18 36.7055 17.8224 37.1572 17.5104 37.4877C16.8659 38.1708 15.8249 38.1708 15.1804 37.4877L15.1802 37.4875Z",
      fill: color
    }, void 0)]
  }), void 0);
});